// extracted by mini-css-extract-plugin
module.exports = {"loginError":"Login_loginError__36PQD","loginForm":"Login_loginForm__1MZnn"};